<template>
    <app-layout>
        <template #header>
            <div class="relative mb-9">
                <div class="absolute mb-4 right-0">
                    <div class="col-span-2">
                        <balance :short="true" />
                    </div>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <em class="fas fa-list mr-2"></em>
                    Autorizações
                </h2>
            </div>
        </template>
        <div class="py-12 mt-9">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000" />
                    <div class="mb-2">
                        <div class="mb-4">
                            <h1 class="font-bold text-2xl">Lista de envios pendentes de autorização</h1>
                        </div>
                    </div>
                    <div>
                        <inertia-table class="text-xs"
                            :enablePageSize="true"
                            :searchFilter="false"
                            :data="transactions"
                            :params="params"
                            :filters="filters"
                            :columns="columns"
                            :multiSelect="true"
                            :enableDisplay="true"
                            :hasIcon="false"
                            routeName="pending-approvals.index"
                            parent="authorizedTransactions"
                            id="id"
                            @change.native="hasSelected">
                            <template v-slot:buttons>
                                <button
                                    class="bg-gray-200 text-gray-400 py-2 px-2 rounded-none"
                                    :class="disableButtons ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'"
                                    @click="disableButtons ? executeApproved() : ''"
                                >
                                    Executar aprovados
                                </button>
                                <button
                                    class="bg-gray-200 text-gray-400 py-2 px-2 rounded-none"
                                    :class="disableButtons ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'"
                                    @click="disableButtons ? rejectSelected() : ''"
                                >
                                    Recusar Selecionados
                                </button>
                                <button
                                    class="bg-gray-200 text-gray-400 py-2 px-2 rounded-none"
                                    :class="disableButtons ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'"
                                    @click="disableButtons ? approveSelected() : ''"
                                >
                                    Aprovar Selecionados
                                </button>
                            </template>

                            <template slot-scope="row" slot="status">
                                <div class="flex items-center">
                                    <div class="text-center align-center items-center my-auto">
                                        <div class="rounded-full hover:bg-gradient-to-br  h-8 w-8 py-2 px-2" :class="statusData(row.item.status).bg" :content="statusData(row.item.status).name" v-tippy>
                                            <em class="text-center " :class="statusData(row.item.status).icon" style="font-size: 15px;">
                                            </em>
                                        </div>
                                    </div>
                                    <div class="px-4">
                                        <span v-if="row.item.execution_date " class="text-left text-gray-400">{{ row.item.execution_date | smallDateTime }}</span>
                                        <span v-else class="text-left text-gray-400">--/--/----</span>
                                    </div>
                                </div>

                            </template>

                            <template slot-scope="row" slot="created">
                                <div class="text-left text-gray-400">{{ row.item.created | smallDateTime }}</div>
                            </template>

                            <template slot-scope="row" slot="user">
                                <div class="text-left font-bold text-gray-500">{{row.item.user.name.toUpperCase() }}</div>
                                <div class="text-left text-gray-400">{{row.item.user.email}}</div>
                            </template>

                            <template slot-scope="row" slot="movement_details">
                                <div :content="getContent(row.item.movement_details)" v-tippy class="text-left  font-bold text-gray-500">
                                    {{getType(row.item.movement_details.type)}}

                                    <div v-if="row.item.movement_details.type != 'boleto'" class="text-xs  text-left text-gray-400">{{row.item.movement_details.destination_account.name.toUpperCase()}}</div>
                                    <div  v-if="row.item.movement_details.type != 'boleto'" class="text-left text-gray-500">
                                        <em class="fas fa-address-card"></em>
                                        {{row.item.movement_details.destination_account.federal_document}}
                                    </div>
                                </div>
                            </template>

                            <template slot-scope="row" slot="amount">
                                <div class=" w-full text-left font-bold text-red-500">
                                    -R${{ row.item.amount | currency }}
                                </div>
                            </template>

                            <template slot-scope="row" slot="approvals">
                                <div v-if="row.item.approvals && row.item.approvals.length" class="text-center text-gray-400">
                                    <dropdown align="center" class="w-full">
                                        <template #trigger>
                                            <button class="bg-transparent" content="Clique para ver as aprovações" v-tippy>
                                                {{row.item.approvals.length}}/{{row.item.total_approvals_required}}
                                            </button>
                                        </template>
                                        <template #content>
                                            <div class="flex items-center m-2 p-2" v-for="approval in row.item.approvals">
                                                <div class="text-center align-center items-center my-auto">
                                                    <div class="rounded-full hover:bg-gradient-to-br  h-8 w-8 py-2 px-2" :class="statusDataAppoval(approval.status).bg">
                                                        <em class="text-center " :class="statusDataAppoval(approval.status).icon" style="font-size: 15px;">
                                                        </em>
                                                    </div>
                                                </div>
                                                <div class="px-4">
                                                    <div class="text-xs text-left text-gray-400">{{approval.name.toUpperCase()}}</div>
                                                </div>
                                            </div>

                                        </template>

                                    </dropdown>
                                </div>
                                <div v-else class="text-center text-gray-400">
                                    0/{{row.item.total_approvals_required}}
                                </div>
                            </template>

                            <template slot-scope="row" slot="actions">
                                <div class="flex items-center">


                                    <!-- btn de exec -->
                                    <div class="text-center align-center items-center my-auto mr-2"
                                        v-if="row.item.status == 'approved'" >
                                        <button class="shadow-2xl rounded-full h-10 w-10 py-2 px-2 cursor-pointer bg-white disabled:opacity-25 disabled:cursor-not-allowed" content="Executar" v-tippy :disabled="isDisabled" @click="execute([row.item.id])">
                                            <em class="text-center mt-1 fas fa-play text-blue-600" style="font-size: 17px;">
                                            </em>
                                        </button>
                                    </div>

                                    <!-- btn de aprovar -->
                                    <div class="text-center align-center items-center my-auto mr-2 cursor-pointer"
                                        v-if="(row.item.status == 'pending' && !hasApproval(row.item.approvals)) || remakeTransaction == row.item.id" >
                                        <button class="shadow-2xl rounded-full h-10 w-10 py-2 px-2 bg-white cursor-pointer disabled:opacity-25 disabled:cursor-not-allowed" content="Aprovar envio" v-tippy :disabled="isDisabled" @click="approve([row.item.id])">
                                            <em class="text-center mt-1  far fa-check-circle text-green-600" style="font-size: 17px;">
                                            </em>
                                        </button>
                                    </div>
                                    <!-- btn de recusar -->
                                    <div class="text-center align-center items-center my-auto mr-2 cursor-pointer"
                                        v-if="(row.item.status == 'pending' && !hasApproval(row.item.approvals)) || remakeTransaction == row.item.id">
                                        <button class="shadow-2xl rounded-full h-10 w-10 py-2 px-2 bg-white disabled:opacity-25 disabled:cursor-not-allowed" content="Recusar envio" v-tippy  :disabled="isDisabled"  @click="reject([row.item.id])">
                                            <em class="text-center mt-1 far fa-times-circle text-red-600" style="font-size: 17px;">
                                            </em>
                                        </button>
                                    </div>

                                    <!-- btn de ver que aprovou -->
                                    <div class="text-center align-center items-center my-auto mr-2 cursor-pointer"
                                        v-if="remakeTransaction !== row.item.id && row.item.status == 'pending' && getApprovalUser(row.item.approvals) == 'approved'" >
                                        <button class="shadow-2xl rounded-full h-10 w-10 py-2 px-2 bg-green-100 disabled:opacity-25 disabled:cursor-not-allowed" content="Você aprovou" v-tippy>
                                            <em class="text-center mt-1 fas fa-check text-green-600" style="font-size: 17px;">
                                            </em>
                                        </button>
                                    </div>

                                    <!-- btn de ver que recusou -->
                                    <div class="text-center align-center items-center my-auto mr-2 cursor-pointer"
                                        v-if="remakeTransaction !== row.item.id && row.item.status == 'rejected' && getApprovalUser(row.item.approvals) == 'rejected'" >
                                        <button class="shadow-2xl rounded-full h-10 w-10 py-2 px-2 bg-red-100 disabled:opacity-25 disabled:cursor-not-allowed" content="Você recusou" v-tippy>
                                            <em class="text-center mt-1 fas fa-times text-red-600" style="font-size: 17px;">
                                            </em>
                                        </button>
                                    </div>

                                    <!-- btn pra mudar resposta -->
                                    <div class="text-center align-center items-center my-auto mr-2 cursor-pointer"
                                        v-if="remakeTransaction !== row.item.id && (row.item.status == 'rejected' && getApprovalUser(row.item.approvals) == 'rejected' || row.item.status == 'pending' && getApprovalUser(row.item.approvals) == 'approved')">
                                        <button class="shadow-2xl rounded-full h-10 w-10 py-2 px-2 bg-transparent disabled:opacity-25 disabled:cursor-not-allowed" content="Refazer" v-tippy  :disabled="isDisabled" @click="reset(row.item.id)">
                                            <em class="text-center mt-1 fas fa-undo text-gray-600" style="font-size: 17px;">
                                            </em>
                                        </button>
                                    </div>


                                </div>
                            </template>
                        </inertia-table>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';
import Input from "../../Jetstream/Input";
import Balance from "../../Helpers/Balance";
import moment from 'moment';


export default {
    components: {
        Balance,
        Input,
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
    },
    props: ['transactions', 'user'],
    data: function () {
        return {
            disableButtons: true,
            remakeTransaction:  null,
            form: this.$inertia.form({
                status: '',
                ids: '',
            }),
            formExec: this.$inertia.form({
                ids: '',
            }),
            formReset: this.$inertia.form({
                id: '',
            }),
            params: {
                sort: 'created:desc',
                page: 1,
                ...this.$page.props.queryString
            },
            filters: [
                {
                    text: 'Período',
                    key: 'interval',
                    type: 'dropdown',
                    colSpan: 2,
                    options: [
                        { id: 'today', name: 'Hoje' },
                        { id: 'yesterday', name: 'Ontem' },
                        { id: '3_days', name: 'Últimos 3 dias' },
                        { id: '7_days', name: 'Últimos 7 dias' },
                        { id: '15_days', name: 'Últimos 15 dias' },
                        { id: '30_days', name: 'Últimos 30 dias' },
                        { id: 'this_month', name: 'Este mês' },
                        { id: 'last_month', name: 'Mês passado' },
                    ]
                },
                {
                    text: 'Data de ínicio',
                    key: 'date_from',
                    type: 'datepicker'
                },
                {
                    text: 'Data do término',
                    key: 'date_to',
                    type: 'datepicker'
                },

            ],
            columns: [
                { text: 'Status/Data de execução', className: 'text-left text-gray-400', key: 'status', sortable: true },
                { text: 'Data de criação', className: 'text-left text-gray-400', key: 'created', sortable: false },
                { text: 'Responsável pelo envio', className: 'text-left text-gray-400', key: 'user', sortable: false },
                { text: 'Detalhes do envio', className: 'text-left text-gray-400', key: 'movement_details', sortable: false },
                { text: 'Valor', className: 'text-left text-gray-400', key: 'amount', sortable: false },
                { text: 'Aprovações', className: 'text-left text-gray-400', key: 'approvals', sortable: false },
                { text: 'Ações', className: 'text-left text-gray-400', key: 'actions', sortable: false },
            ],
            isDisabled: false,
        }
    },
    methods: {
        hasSelected() {
            this.disableButtons = this.transactions.list.filter(item => item.selected === true).length > 0;
        },
        remake(id) {
           this.remakeTransaction = id;
        },
        execute(ids) {

            if(this.isDisabled) {
                return;
            }

            this.isDisabled = true;
            this.formExec.ids = ids;
            this.formExec.post(route('pending-approvals.execute'), {
                preserveScroll: true,
            }).then(() => {
                this.isDisabled = false;
            });

            this.transactions.list.map(item => item.selected = false);
            this.remakeTransaction = null;
        },
        reset(id) {

            if(this.isDisabled) {
                return;
            }


            this.isDisabled = true;
            this.formReset.id = id;
            this.formReset.post(route('pending-approvals.reset-my-approval'), {
                preserveScroll: true,
            }).then(() => {
                this.isDisabled = false;
            });

        },
        executeApproved() {
            let itemSelected = this.transactions.list
                .filter(item => item.status == 'approved')
                .map(item => item.id);

            if (!itemSelected.length) {
                this.$toast.open({
                    'message': 'Nenhuma transação aprovada selecionada',
                    'type': 'error',
                    'position': 'top-right',
                    'duration': 5000
                });
                return;
            }

            this.execute(itemSelected);

        },
        approveSelected() {
            let itemSelected = this.transactions.list
                .filter(item => item.status == 'pending' || (item.status == 'rejected' && this.getApprovalUser(item.approvals) == 'rejected'))
                .filter(item => item.selected == true)
                .map(item => item.id);

            if (!itemSelected.length) {
                this.$toast.open({
                    'message': 'Nenhuma transação pendente selecionada',
                    'type': 'error',
                    'position': 'top-right',
                    'duration': 5000
                });
                return;
            }

            this.approve(itemSelected);
        },
        rejectSelected() {
            let itemSelected = this.transactions.list
                .filter(item => item.status == 'pending')
                .filter(item => item.selected == true)
                .map(item => item.id);

            if (!itemSelected.length) {
                this.$toast.open({
                    'message': 'Nenhuma transação pendente selecionada',
                    'type': 'error',
                    'position': 'top-right',
                    'duration': 5000
                });
                return;
            }


            this.reject(itemSelected);

        },
        hasApproval(approvals) {
            approvals = approvals || [];
            let user = this.user;
            let hasApproval = approvals.filter(approval => approval.id == user.id);

            return hasApproval.length > 0 ? true : false;
        },
        getApprovalUser(approvals) {
            approvals = approvals || [];
            let user = this.user;
            let approval = approvals.filter(approval => approval.id == user.id);
            if (approval.length > 0) {
                return approval[0].status;
            }
            return 'undefined';
        },
        reject(ids) {

            if(this.isDisabled) {
                return;
            }

            this.form.ids = ids;
            this.form.status = 'rejected';
            this.form.post(route('pending-approvals.update'), {
                preserveScroll: true,
            });

            this.transactions.list.map(item => item.selected = false);
            this.remakeTransaction = null;
        },
        approve(ids) {

            if(this.isDisabled) {
                return;
            }

            this.isDisabled = true;
            this.form.ids = ids;
            this.form.status = 'approved';
            this.form.post(route('pending-approvals.update',), {
                preserveScroll: true
            }).then(() => {
                this.isDisabled = false;
            });

            this.transactions.list.map(item => item.selected = false);
            this.remakeTransaction = null;
        },
        getType(type) {
            switch (type) {
                case 'pix':
                    return 'Envio de Pix';
                case 'p2p':
                    return 'Transferência entre contas 2GO';
                case 'ted':
                    return 'TED';
                case 'boleto':
                    return 'Boleto';
                default:
                    return 'bg-gray-500';
            }
        },
        getContent(item) {

            let html = `Detalhes da transferência <br>`;
            if (item.type == 'pix' && item.pix_key) {
                html += `Chave do pix:<br> <b>${item.pix_key}</b><br>`;
            }else if (item.type == 'boleto' && item.barcode) {
                html += `Código do boleto:<br> <b>${item.barcode}</b><br>`;
            }else if (item.destination_account) {
                if(item.destination_account.bank) {
                    html += `Banco do favorecido <br> <b>${item.destination_account.bank.name} </b> <br>`;
                }
                if(item.destination_account.agency && item.destination_account.number) {
                    html += `<b>Ag: ${item.destination_account.agency} Cc: ${item.destination_account.number}</b> <br>`;
                }
            }
            return html;
        },
        statusDataAppoval(status) {
            switch (status) {
                case 'rejected':
                    return { bg: 'bg-red-100', icon: 'far fa-times-circle text-red-400', name: 'Recusada' };
                case 'pending':
                    return { bg: 'bg-yellow-300', icon: 'far fa-hourglass text-yellow-600', name: 'Pendente de aprovação' };
                case 'approved':
                    return { bg: 'bg-blue-100', icon: 'far fa-play-circle text-blue-400', name: 'Pendente de execução' };
                default:
                    return { bg: 'bg-yellow-500', icon: 'far fa-play-circle text-gray-500', name: 'Pendente de execução' };
            }
        },
        statusData(status) {
            switch (status) {
                case 'active':
                    return { bg: 'bg-green-100', icon: 'far fa-check-circle text-green-400', name: 'Concluido' };
                case 'rejected':
                    return { bg: 'bg-red-100', icon: 'far fa-times-circle text-red-400', name: 'Recusada' };
                case 'pending':
                    return { bg: 'bg-yellow-300', icon: 'far fa-hourglass text-yellow-600', name: 'Pendente de aprovação' };
                case 'approved':
                    return { bg: 'bg-blue-100', icon: 'far fa-play-circle text-blue-400', name: 'Pendente de execução' };
                case 'in_progress':
                    return { bg: 'bg-yellow-100', icon: 'far fa-play-circle text-yellow-400', name: 'Em execução' };
                case 'error':
                    return { bg: 'bg-red-100', icon: 'far fa-times-circle text-red-400', name: 'Erro' };
                case 'paid':
                    return { bg: 'bg-green-100', icon: 'far fa-check-circle text-green-400', name: 'Pago' };
                default:
                    return { bg: 'bg-gray-100', icon: 'fas fa-question-circle text-gray-400', name: 'Não definido' };
            }
        },
        getActions(actions) {
            switch (actions) {
                case 'run':
                    return { bg: 'bg-white', icon: 'fas fa-play text-blue-600', name: 'Executar' }
                case 'approve-send':
                    return { bg: 'bg-white', icon: 'far fa-check-circle text-green-600', name: 'Aprovar envio' }
                case 'refuse-send':
                    return { bg: 'bg-white', icon: 'far fa-times-circle text-red-600', name: 'Recusar envio' }
                case 'redo':
                    return { icon: 'fas fa-redo text-gray-700', name: 'Refazer' }
                case 'you-approved':
                    return { bg: 'bg-green-100', icon: 'far fa-check-circle text-green-600', name: 'Você aprovou' }
                case 'you-refused':
                    return { bg: 'bg-red-100', icon: 'far fa-times-circle text-red-600', name: 'Você recusou' }
                default:
                    return { text: 'Finalizado', name: 'Finalizado' }

            }
        }
    },
    created() {
        this.hasSelected()
    }
}

</script>

